import { jsx as _jsx } from "react/jsx-runtime";
import { chipClasses } from './styles.js';
/**
 * v2 チップ primitive（S-133）。rounded-full の小ラベル（13px / 500）で、面と文字を
 * 状態色トークン（brand / success / warning / neutral）から取る。v1 の Badge（生 emerald /
 * amber）の後継で、v2 に移行した画面ではこちらを使う。
 */
export function Chip({ tone, className, ...rest }) {
    return _jsx("span", { className: chipClasses({ tone, className }), ...rest });
}
//# sourceMappingURL=Chip.js.map